export const SCHEDULER_TYPES = [
    { name: 'Send Invoice', value: 'SEND_INVOICE' },
    { name: 'Reminder Invoice', value: 'REMINDER_INVOICE' }
]